import { useEffect, useState } from "react";
import { CheckCircle2, Mail, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/common";
import { adminApi, errMsg, fmtDateTime } from "@/lib/api";
import { AjudaManualBox } from "@/components/admin/AjudaManualBox";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

function RequestCard({ r, onStatus }) {
  const open = r.status === "aberto";
  return (
    <div className={cn("card-surface space-y-2 p-4", !open && "opacity-70")} data-testid={`support-request-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <Badge variant="outline" className={cn("border-0 ring-1", open ? "bg-amber-500/15 text-amber-500 ring-amber-500/30" : "bg-emerald-500/15 text-emerald-500 ring-emerald-500/30")}>{open ? "Aberto" : "Resolvido"}</Badge>
        <span className="font-semibold">{r.category}</span>
        <span className="text-sm text-muted-foreground">· {r.store} (código {r.access_number}) · {r.user_name}</span>
        <span className="ml-auto text-xs text-muted-foreground">{fmtDateTime(r.created_at)}</span>
      </div>
      <p className="whitespace-pre-wrap text-sm" data-testid={`support-request-message-${r.id}`}>{r.message}</p>
      <div className="flex flex-wrap items-center gap-2">
        {r.reply_to && <Button asChild size="sm" variant="outline"><a href={`mailto:${r.reply_to}?subject=${encodeURIComponent(`Re: ${r.category}`)}`} data-testid={`support-reply-${r.id}`}><Mail className="h-4 w-4 mr-1" />Responder {r.reply_to}</a></Button>}
        <Button size="sm" variant="ghost" onClick={() => onStatus(r, open ? "resolvido" : "aberto")} data-testid={`support-toggle-${r.id}`}>
          {open ? <><CheckCircle2 className="h-4 w-4 mr-1" />Marcar como resolvido</> : <><RotateCcw className="h-4 w-4 mr-1" />Reabrir</>}
        </Button>
        {!r.email_sent && <span className="text-xs text-muted-foreground">Aviso por e-mail não enviado</span>}
      </div>
    </div>
  );
}

export function SupportTab() {
  const [list, setList] = useState(null);
  const load = () => adminApi.get("/support-requests").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const onStatus = async (r, status) => {
    try { await adminApi.patch(`/support-requests/${r.id}`, { status }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!list) return null;
  const openCount = list.filter((r) => r.status === "aberto").length;
  return (
    <div className="space-y-4" data-testid="support-tab">
      <AjudaManualBox />
      <div>
        <p className="font-display text-xl font-bold">Pedidos de ajuda</p>
        <p className="text-sm text-muted-foreground" data-testid="support-open-count">{openCount} em aberto · enviados pelos clientes em "Fale com o suporte"</p>
      </div>
      {list.length ? list.map((r) => <RequestCard key={r.id} r={r} onStatus={onStatus} />) : <EmptyState title="Nenhum pedido de ajuda ainda" />}
    </div>
  );
}
